import { ChangeEvent, memo } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Resources from "../../config/Resources";

interface Props {
  className?: string;
  optionsClassName?: string;
  options: Record<string, any>;
  onChange: (e: ChangeEvent<any>) => void;
  value: string;
  defaultValue?: string;
  innerClassName?: string;
  buttonBgColor?: string; // tailwind utitlity class required
  iconClassName?: string;
  isBordered?: boolean;
  name: string;
  disabled?: boolean;
}
function DashboardSelectField({
  className,
  options,
  onChange,
  value,
  optionsClassName,
  buttonBgColor,
  innerClassName,
  defaultValue,
  isBordered,
  iconClassName,
  name,
  disabled
}: Props) {
  console.log("Dashboard options", options);
  return (
    <div className={className}>
      <div
        className={`${
          isBordered &&
          "rounded-lg border-0 border-solid border-discoBall focus-within:border-2 focus-within:border-hotShots"
        } ${isBordered && "border-2 border-hotShot"} ${innerClassName}`}
      >
        <TextField
          disabled={disabled}
          fullWidth
          select
          variant="standard"
          name={name}
          onChange={onChange}
          value={value}
          defaultValue={defaultValue}
          SelectProps={{
            // eslint-disable-next-line react/no-unstable-nested-components
            IconComponent: () => (
              <div
                className={`absolute right-0 pointer-events-none z-10 flex justify-center items-center ${iconClassName} ${buttonBgColor}`}
              >
                {disabled ? (
                  <img src={Resources.images.Dashboard.upDisableIcon} alt="down disabled arrow" />
                ) : (
                  <img src={Resources.images.Dashboard.upIcon} alt="down arrow" />
                )}
              </div>
            ),
            classes: {
              root: "!bg-transparent !cursor-pointer"
            }
          }}
          InputProps={{
            classes: {
              input: `!text-xs !leading-5 !font-medium !text-black !rounded-lg !font-montserrat ${buttonBgColor}`,
              root: "!rounded-lg w-60 !text-left",
              disabled: "!bg-gray-200"
            },
            disableUnderline: true
          }}
        >
          {Object.entries(options)?.map(([key, objectValue]) => (
            <MenuItem
              disabled={!objectValue?.enabled}
              key={key}
              value={key}
              classes={{ root: `!font-montserrat !font-medium !text-xs ${optionsClassName}` }}
            >
              {key}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );
}

DashboardSelectField.defaultProps = {
  className: "",
  optionsClassName: "",
  buttonBgColor: "!bg-transparent",
  innerClassName: "",
  isBordered: true,
  iconClassName: "",
  defaultValue: "",
  disabled: false
};

export default memo(DashboardSelectField);
